export default __webpack_public_path__ + "static/lBlock-31ca88a6919fb2c91aafa0016bac8dda.svg";